var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/NormalizeTypesPlugin.ts
import {
  createTSlatePlugin
} from "@udecode/plate-common";

// src/lib/withNormalizeTypes.ts
import {
  getNode,
  insertElements,
  isElement,
  setElements
} from "@udecode/plate-common";
var withNormalizeTypes = ({
  editor,
  getOptions
}) => {
  const { normalizeNode } = editor;
  editor.normalizeNode = ([currentNode, currentPath]) => {
    const { rules, onError } = getOptions();
    if (currentPath.length === 0) {
      const endCurrentNormalizationPass = rules.some(
        ({ path, strictType, type }) => {
          const node = getNode(editor, path);
          if (node) {
            if (strictType && isElement(node) && node.type !== strictType) {
              const _a = editor.api.create.block({
                type: strictType
              }), { children } = _a, props = __objRest(_a, ["children"]);
              setElements(editor, props, {
                at: path
              });
              return true;
            }
          } else {
            try {
              insertElements(
                editor,
                editor.api.create.block({ type: strictType != null ? strictType : type }),
                { at: path }
              );
              return true;
            } catch (error) {
              onError == null ? void 0 : onError(error);
            }
          }
          return false;
        }
      );
      if (endCurrentNormalizationPass) {
        return;
      }
    }
    return normalizeNode([currentNode, currentPath]);
  };
  return editor;
};

// src/lib/NormalizeTypesPlugin.ts
var NormalizeTypesPlugin = createTSlatePlugin({
  key: "normalizeTypes",
  extendEditor: withNormalizeTypes,
  options: {
    rules: []
  }
});

// src/lib/RemoveEmptyNodesPlugin.ts
import { createTSlatePlugin as createTSlatePlugin2 } from "@udecode/plate-common";

// src/lib/withRemoveEmptyNodes.ts
import {
  getNodeString,
  isElement as isElement2,
  removeNodes
} from "@udecode/plate-common";
import castArray from "lodash/castArray.js";
var withRemoveEmptyNodes = ({
  editor,
  getOptions
}) => {
  const { normalizeNode } = editor;
  editor.normalizeNode = ([node, path]) => {
    var _a;
    const types = castArray((_a = getOptions().types) != null ? _a : []);
    if (isElement2(node) && node.type && types.includes(node.type) && getNodeString(node) === "") {
      removeNodes(editor, { at: path });
      return;
    }
    normalizeNode([node, path]);
  };
  return editor;
};

// src/lib/RemoveEmptyNodesPlugin.ts
var RemoveEmptyNodesPlugin = createTSlatePlugin2({
  key: "removeEmptyNodes",
  extendEditor: withRemoveEmptyNodes
});
export {
  NormalizeTypesPlugin,
  RemoveEmptyNodesPlugin,
  withNormalizeTypes,
  withRemoveEmptyNodes
};
//# sourceMappingURL=index.mjs.map